export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_USER = "LOGIN_USER";
export const UPDATE_LAST_VISITED_PAGE = "UPDATE_LAST_VISITED_PAGE";
